<template>
  <div class="country">
      <!-- <div v-for="(item,index) in dict" :keys="index">
          <div v-if="item.sty == 'title'" class="countrytitle">{{item.content}}</div>
          <div v-else class="countryitem" @click="changeconutry(item)"><p>{{item.content}}</p><img :src="'static/images/country/'+item.src+'.png'" /></div>
      </div> -->

    <div class="main_content">
      <img class="close_btn_m hidden_pc" @click="$emit('close')" src="../../images/country_close.png" alt="">
      <img class="close_btn hidden_m" @click="$emit('close')" src="static/images/close.png" alt="">
      <div class="switch_tab_con">
        <!-- <div
          :class="{
            switch_tab_item: true,
            active: activeType === 'country'
          }"
          @click="activeType = 'country'"
        >
          <P class="switch_title">{{ $t('country.countryTitle1') }}</P>
          <p class="switch_content">{{ $t(`country.${currentConutry.content}`)}}</p>
        </div> -->
        <div
          :class="{
            switch_tab_item: true,
            active: activeType === 'lang'
          }"
          @click="activeType = 'lang'"
        >
          <P class="switch_title">{{ $t('country.countryLanguage1') }}</P>
          <p class="switch_content">{{ localeMap[currentLocale] }}</p>
        </div>
      </div>
      <!-- <div class="list_content" :key="activeType" v-if="activeType === 'country'">
        <template v-for="(item,index) in dict">
          <div v-if="item.sty == 'title'" class="country_title" :key="index">
            {{ $t(`country.${item.content}`)}}
          </div>
          <div
            v-else
            :class="{country_item: true, active: curConutry.content === item.content}"
            @click="toggleConutry(item)"
            :key="index"
          >
            <span>{{ $t(`country.${item.content}`)}}</span>
            <img class="country_pic" v-if="item.src" :src="'static/images/country/'+item.src+'.png'" />
          </div>
        </template>
      </div> -->
      <div class="list_content" :key="activeType" v-if="activeType === 'lang'">
        <div
          v-for="item in langList"
          :key="item[0]"
          :class="{lang_item: true, active: item[0] === curLocal}"
          @click="toggleLang(item)"
        >
          {{ item[1] }}
        </div>
      </div>
      <div class="confirm_btn hidden_m" @click="submit">{{ $t('game.confirm') }}</div>
    </div>
  </div>
</template>
<script>
import conutryarr from '../country.js'
import {localeMap} from '../../../tool/constant';

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
export default {
  props: [
    'currentConutry',
    'currentLocale'
  ],
  data() {
    return {
      isMobileDevice: isMobileDevice(),
      dict: conutryarr,
      localeMap,
      activeType: 'lang',
      curConutry: this.currentConutry,
      curLocal: this.currentLocale,
    }
  },
  computed: {
    langList() {
      return Object.entries(this.localeMap)
    },
  },
  methods:{
    toggleConutry(item){
      this.curConutry = item
      if (!this.isMobileDevice) return
      this.$emit('selectConutry', item)
      this.$emit('close')
    },
    toggleLang(item) {
      this.curLocal = item[0]
      if (!this.isMobileDevice) return
      this.$emit('selectLang', item[0])
      this.$emit('close')
      window.location.reload()
    },
    submit() {
      // this.$emit('selectConutry', this.curConutry)
      if (this.curLocal !== this.currentLocale) {
        this.$emit('selectLang', this.curLocal)
        window.location.reload()
      }
      this.$emit('close')
    }
  },
}
</script>
<style scoped>
  @media (max-width: 1024px) {
    .hidden_m{
      display: none !important;
    }
  }
  @media (min-width: 1024px) {
    .hidden_pc{
      display: none !important;
    }
  }


  .country{
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .7);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .main_content{
    position: relative;
    width: 750px;
    max-width: 100%;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 40px 20px;
    background: #254167;
  }
  .close_btn{
    position: absolute;
    top: -48px;
    right: -48px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  .switch_tab_con{
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    /* padding: 0 16px; */
  }
  .switch_tab_con .switch_tab_item{
    height: 60px;
    width: 100%;
    background: #254167;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .switch_tab_con .switch_tab_item .switch_title{
    font-size: 15px;
    line-height: 15px;
    font-weight: normal;
    color: #fff;
    margin-bottom: 6px;
  }
  .switch_tab_con .switch_tab_item .switch_content{
    font-size: 13px;
    line-height: 13px;
    font-weight: normal;
    color: #38e687;
  }
  .switch_tab_con .switch_tab_item.active{
    background: #293549;
  }
  .list_content{
    background: #293549;
    overflow: auto;
    padding: 10px;
    height: 50vh;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .list_content::-webkit-scrollbar {
    width: 4px;
  }

  .list_content::-webkit-scrollbar-track {
    background: transparent;
  }

  .list_content::-webkit-scrollbar-thumb {
    background-color: #e1e1e1;
  }

  .list_content::-webkit-scrollbar-thumb:hover {
    background: #e1e1e1;
  }
  .country_title{
    height: 50px;
    box-sizing: border-box;
    font-size: 15px;
    color: #fff;
    /* border-bottom: 1px solid #444c64; */
    display: flex;
    align-items: center;
    flex-basis: 100%;
  }
  .country_item{
    height: 50px;
    box-sizing: border-box;
    font-size: 13px;
    color: #c5c7c6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;
    flex-basis: calc(33.333% - 10px);
    margin: 5px;
    border: 1px solid #444c64;
    border-radius: 4px;
    padding: 0 20px;
    cursor: pointer;
  }
  .country_item:hover, .country_item.active{
    color: #fff;
    border-color: #fff;
    font-weight: 500;
  }
  .country_pic{
    width: auto;
    height: 24px;
  }
  .lang_item{
    height: 50px;
    box-sizing: border-box;
    border: 1px solid #444c64;
    border-radius: 4px;
    font-size: 13px;
    color: #c5c7c6;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-basis: calc(33.333% - 10px);
    margin: 5px;
    padding: 0 20px;
    cursor: pointer;
  }
  .lang_item:hover, .lang_item.active{
    color: #fff;
    font-weight: 500;
    border-color: #fff;
  }

  .confirm_btn{
    height: 40px;
    width: 160px;
    background: rgba(7, 194, 97, 1);
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-top: 24px;
    cursor: pointer;
  }

  @media (max-width: 1024px) {
    .country{
      overflow-y: auto;
      position: fixed;
      top: 3.125rem;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: #254167;
      padding: 42px 0 0;
      box-sizing: border-box;
      z-index: 99999;
    }
    .main_content{
      position: relative;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      padding: 0;
      background: #254167;
    }
    .close_btn_m{
      position: absolute;
      top: -28px;
      right: 10px;
      width: 15px;
      height: 15px;
      cursor: pointer;
    }
    .list_content{
      flex-grow: 1;
      background: #293549;
      overflow: auto;
      padding: 0 10px;
    }
    .list_content::-webkit-scrollbar {
      width: 4px;
    }

    .list_content::-webkit-scrollbar-track {
      background: transparent;
    }

    .list_content::-webkit-scrollbar-thumb {
      background-color: #e1e1e1;
    }

    .list_content::-webkit-scrollbar-thumb:hover {
      background: #e1e1e1;
    }
    .country_title{
      height: 50px;
      box-sizing: border-box;
      font-size: 15px;
      color: #fff;
      border-bottom: 1px solid #444c64;
      display: flex;
      align-items: center;
      flex-basis: 100%;
    }
    .country_item{
      height: 50px;
      box-sizing: border-box;
      font-size: 13px;
      color: #c5c7c6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: row;
      flex-basis: 100%;
      margin: 0;
      border: none;
      padding: 0;
    }
    .country_item.active{
      color: #fff;
      font-weight: 500;
    }
    .country_pic{
      width: auto;
      height: 24px;
    }
    .lang_item{
      height: 50px;
      box-sizing: border-box;
      border-right: none;
      border-left: none;
      border-top: none;
      border-radius: none;
      border-bottom: 1px solid #444c64;
      font-size: 13px;
      color: #c5c7c6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-basis: 100%;
      padding: 0;
    }
    .lang_item.active{
      color: #fff;
      font-weight: 500;
      border-color: #444c64;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/head/toggleModal.vue